import { useEffect, useRef } from 'react';
import { SVG } from '@svgdotjs/svg.js';

import useStore from '../../store/store';
import { IntersectionCoordinates } from '../../utility';

const Line = () => {
	const lineRef = useRef();
	
	const sourceHeight = useStore((state) => state.sourceHeight);
	const receiverHeight = useStore((state) => state.receiverHeight);
	const distance = useStore((state) => state.distance);
	const getSoundSourcePosition = useStore((state) => state.getSoundSourcePosition);
	const getUnitFromMeter = useStore((state) => state.getUnitFromMeter);

	const barrierHeight = useStore((state) => state.scenario === 'noBarriers' ? 0 : state.barrier1.height);
	const barrierXpos = useStore((state) => state.scenario === 'noBarriers' ? 0 : state.barrier1.distance);

	const { height: barrier2Height, distance: barrier2Distance } = useStore(
		(state) => (state.scenario === 'noBarriers' || state.scenario === 'singleBarrier') ? { height: 0, distance: 0 } : state.barrier2
	);

	useEffect(() => {
		const draw = SVG('#main');
		const g = draw.group();
		const { x, y } = getSoundSourcePosition();
		
		g.transform({ translateX: x, translateY: y });
		lineRef.current = g.polyline().stroke({ color: '#ef7521', dasharray: '5.5', width: '1', linecap: 'round' }).fill('none').id('line');
	}, []);

	useEffect(() => {
		function IsABarrierAboveSourceReceiver() {
			const { y: y1 } = IntersectionCoordinates(
				{ x0: 0, y0: sourceHeight },
				{ x1: distance, y1: receiverHeight },
				{ x: barrierXpos },
			);
			const { y: y2 } = IntersectionCoordinates(
				{ x0: 0, y0: sourceHeight },
				{ x1: distance, y1: receiverHeight },
				{ x: barrier2Distance },
			);
			return barrier2Height > y2 || barrierHeight > y1;
		}
		if (lineRef.current) {
			let barriers = [{ distance: barrierXpos, height: barrierHeight }, { distance: barrier2Distance, height: barrier2Height }];
			barriers = Number(barrier2Distance) < Number(barrierXpos) ? [{ ...barriers[1] }, { ...barriers[0] }] : barriers;
			
			const isABarrierAboveSourceReceiver = IsABarrierAboveSourceReceiver();
			// closest barrier, intersection coordinates
			const { x: x1, y: y1 } = IntersectionCoordinates(
				{ x0: 0, y0: sourceHeight },
				isABarrierAboveSourceReceiver ? { x1: barriers[1].distance, y1: barriers[1].height } : { x1: distance, y1: receiverHeight },
				{ x: barriers[0].distance },
			);
			// farthest barrier, intersection coordinates
			const { x: x2, y: y2 } = IntersectionCoordinates(
				isABarrierAboveSourceReceiver ? { x0: barriers[0].distance, y0: barriers[0].height } : { x0: 0, y0: sourceHeight },
				{ x1: distance, y1: receiverHeight },
				{ x: barriers[1].distance },
			);

			lineRef.current.plot(`
				0,-${getUnitFromMeter(sourceHeight)}
				${getUnitFromMeter(x1)},-${getUnitFromMeter(y1 > barriers[0].height ? y1 : barriers[0].height)}
				${getUnitFromMeter(x2)},-${getUnitFromMeter(y2 > barriers[1].height ? y2 : barriers[1].height)}
				${getUnitFromMeter(distance)},-${getUnitFromMeter(receiverHeight)}
			`);
		}
	}, [sourceHeight, receiverHeight, distance, barrierHeight, barrierXpos, barrier2Distance, barrier2Height]);

	return null;
};

export { Line };